<template>
  <router-link
    v-if="canViewLink"
    :to="{ name: page.name, params: page.params }"
    :title="page.libelle"
  >
    <div
      :id="
        page.name === 'neopass_form' ? 'menu-neopass-list' : `menu-${page.name}`
      "
      class="relative text-lg leading-5 text-white group flex items-center space-x-4 my-3 px-6 focus:outline-none transition ease-in-out duration-150 hover:bg-indigo-700"
      :class="{
        'bg-indigo-700 border-r-2 border-pink-600':
          currentPage === page.link ||
          (page.link != '/' &&
            currentPage.includes('cartographies/collectives') &&
            currentPage.includes(page.link)),
        'justify-start': isFullMenu,
        'justify-center': !isFullMenu,
      }"
    >
      <div
        class="p-4 h-full"
        :class="{
          'border-pink-600 border rounded-lg':
            currentPage === page.link ||
            (page.link != '/' &&
              currentPage.includes('cartographies/collectives') &&
              currentPage.includes(page.link)),
        }"
      >
        <icon
          :name="page.icon"
          class="h-5 w-5 text-gray-300 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
          :label="page.libelle"
        />
      </div>
      <p :class="(isFullMenu ? '' : 'hidden') + ' pt-1'">
        {{ page.libelle }}
      </p>
      <beta-tag
        v-if="page.link === 'competences'"
        :class="isFullMenu ? '' : 'absolute transform scale-75 top-0'"
      />
    </div>
  </router-link>
</template>

<script>
import Icon from './Icon';
import Constants from './../constants';
import BetaTag from './BetaTag.vue';

export default {
  name: 'MenuLink',

  components: { Icon, BetaTag },

  props: {
    page: {
      type: Object,
      required: true,
    },
    currentPage: {
      type: String,
      required: true,
    },
    isFullMenu: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      constants: Constants,
    };
  },

  methods: {
    canViewLink() {
      const canSeeDashboard =
        this.page.name === 'Dashboard' &&
        this.$store.getters['auth/role'] !== Constants.ROLE_BENEFICIAIRE;
      return (
        !this.page.permission_name_read ||
        this.$can(this.page.permission_name_read) ||
        canSeeDashboard
      );
    },
  },
};
</script>

<style scoped></style>
